import logError from '@/utils/errors/logError';

import {WebViewService} from './WebViewService';

export const initializeWebView = async () => {
  try {
    WebViewService.initWebView();
  } catch (error) {
    logError(error, {
      fileName: 'WebViewFActory',
      functionName: 'initializeWebView',
    });
  }
};

export const getWebViewService = () => WebViewService;
